import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { FC } from 'react'

interface LabelProps {
    children: string
}

const Label: FC<LabelProps> = ({ children }) => {
    return (
        <Typography.Description
            size="small"
            font="medium"
            numberOfLines={1}
            style={{ color: ColorEnum.GRAY_600, flex: 1 }}
        >
            {children}
        </Typography.Description>
    )
}

export default Label
